<template>
    <div class="transfer">
        <div class="transfer-bg"></div>
        <div class="transfer-nav">
            <img @click="goBack" class="arrow-icon" src="../../assets/img/me/icon9.png" alt="" />
            <span>{{ $t('transfer.transfer') }}</span>
            <img class="record-icon" @click="go('/record')" src="../../assets/img/me/icon8.png" alt="" />
        </div>
        <div class="placeholder"></div>
        <div class="px20">
            <div class="title">
                {{ $t('transfer.address') }}
            </div>
            <div class="ipt">
                <Field v-model="value" :placeholder="$t('transfer.pla')" />

            </div>

            <div class="title">
                {{ $t('transfer.transferCoin') }}

            </div>

            <div class="ipt">
                <Field v-model="value" placeholder="YUX">
                    <template #extra>
                        <div class="ipt-arrow">
                            <img src="../../assets/img/me/icon7.png" alt="">
                        </div>
                    </template>
                </Field>

            </div>



            <div class="title">
                {{ $t('transfer.network') }}
            </div>
            <div class="ipt">
                <Field v-model="value" :placeholder="$t('transfer.mainNetwork')" />

            </div>
            <div class="title">
                {{ $t('transfer.transferAmount') }}
            </div>
            <div class="ipt">
                <Field v-model="value" :placeholder="$t('transfer.withdraw')">
                    <template #extra>
                        <div class="ipt-text">
                            <span > YUX</span>
                            <div class="ipt-arrow">
                            <img src="../../assets/img/me/icon7.png" alt="">
                        </div>
                        </div>
                    </template>
                </Field>

            </div>

            <div class="desc">
                <div class="label">{{ $t('transfer.balance') }}:</div>
                <div class="value">
                    200 YUX
                    <span>全部</span>
                </div>
            </div>

            <div class="tips">
                *{{ $t('transfer.tips') }}
            </div>

            <div class="transfer-footer">
                <div>
                    <div class="label">{{ $t('transfer.amountReceived') }}</div>
                    <div class="value">300 YUX</div>
                    <div class="procedures">
                        {{ $t('transfer.free') }} <span>2NEX</span>
                    </div>
                </div>
                <div class="btn">
                    {{ $t('transfer.transfer') }} 
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import {
    Field,
    Swipe,
    SwipeItem,
    Circle,
    Tab,
    Tabs,
    Popup,
    Progress,
    Button,
    Popover
} from "vant";
import { copyToClipboard } from "@/utils";
import NumberScroll from "@/components/NumberScroll.vue";
import SplitText from "@/components/SplitText/SplitText.vue";
import ShinyText from "@/components/ShinyText/ShinyText.vue";
import AnimatedContent from "@/components/AnimatedContent/AnimatedContent.vue";
import FadeContent from "@/components/FadeContent/FadeContent.vue";
import QRCode from 'qrcode'

export default {
    name: "transfer",
    components: {
        Popover,
        SplitText,
        ShinyText,
        AnimatedContent,
        FadeContent,
        Field,
        Swipe,
        SwipeItem,
        Tab,
        VanCircle: Circle,
        Tabs,
        Popup,
        Progress,
        Button,
        NumberScroll,
    },
    data() {
        return {
            value: "",
            dd: 0.0,
            qrcodeUrl: '',
            showPopover: false
        };
    },
    computed: {},
    mounted() {

    },
    methods: {
        goBack() {
            this.$router.back()
        },
        go(path) {
            this.$router.push(path)
        }
    },
};
</script>

<style lang="less" scoped>
.transfer {
    position: relative;
    overflow: auto;
    flex: 1;
    height: 100%;
    background-size: 100% 800px;
    padding: 0 0 32px;
    background: url("../../assets/img/home/header-bg.png") no-repeat;
    background-size: 471.9px 240.62px;
    background-position: -60px -97px;
    display: flex;
    flex-direction: column;

    &-bg {
        width: 375px;
        position: absolute;
        height: 200px;
        background: url('../../assets/img/me/header-bg.png') no-repeat center;
        top: -44px;
        background-size: 100% 100%;
    }


    &-nav {
        position: fixed;
        top: 0;
        width: 100%;
        max-width: 375px;
        padding: 10px 20px 10px 19px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 16px;
        font-weight: 500;
        line-height: 16px;

        .arrow-icon {
            width: 24px;
            height: 24px;
        }

        .record-icon {
            width: 20px;
            height: 20px;
        }
    }

    .placeholder {
        height: 44px;
    }

    .px20 {
        padding: 0 20px;
        flex: 1;
        display: flex;
        flex-direction: column;
        position: relative;
        z-index: 2;
    }

    .title {
        margin-top: 24px;
        line-height: 14px;
        height: 14px;
        font-weight: 500;
    }

    .ipt {
        margin-top: 12px;
        border-radius: 16px;
        border: 1px solid rgba(64, 64, 64, 0.5);
        overflow: hidden;
        background: linear-gradient(257deg, #1E1D24 11%, #13121B 75%);
        display: flex;
        align-items: center;
        box-shadow: -20px 68px 20px 0px rgba(0, 0, 0, 0), -13px 43px 18px 0px rgba(0, 0, 0, 0.01), -7px 24px 15px 0px rgba(0, 0, 0, 0.04), -3px 11px 11px 0px rgba(0, 0, 0, 0.07), -1px 3px 6px 0px rgba(0, 0, 0, 0.08);

        &-arrow {
            img {
                width: 24px;
                height: 24px;
            }
        }


        &-text {
            color: #fff;
            display: flex;
            align-items: center;
            > div {
                margin-left: 8px;
            }
        }
    }

    .desc {
        margin-top: 16px;
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        line-height: 12px;

        .label {
            opacity: 0.6;
        }

        .value {
            span {
                margin-left: 21px;
                background: linear-gradient(120deg, #0DF1D5 1%, #0190D1 97%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
            }
        }
    }

    .tips {
        margin-top: 58px;
        font-size: 12px;
        line-height: 14px;
        opacity: 0.6;
    }

    &-footer {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;

        .label {
            font-size: 10px;
            color: #999999;
            line-height: 10px;
        }

        .value {
            margin-top: 8px;
            font-size: 16px;
            font-weight: 800;
            line-height: 16px;
        }

        .procedures {
            margin-top: 8px;
            font-size: 10px;
                opacity: 0.6;
             color: #fff;

         
        }

        .btn {
            display: flex;
            align-items: center;
            justify-content: center;
            background: url('../../assets/img/me/btn-bg.png') no-repeat;
            background-size: 100% 100%;
            font-weight: 500;
            width: 100px;
            font-size: 14px;
            cursor: pointer;
            margin-bottom: 2px;
            line-height: 16px;
            border-radius: 16px;
            height: 40px;
            color: #000000;
        }
    }


}
</style>
<style lang="less">
.transfer {
    .ipt {
        height: 48px;
        padding: 16px;

        .van-cell {
            padding: 0;
            background-color: transparent;

            input {
                color: #fff;
                opacity: 0.6;

                &::placeholder {
                    color: #fff;
                    opacity: 0.6;
                }
            }
        }
    }
}
</style>